export default "__VITE_ASSET__BQojBnxO__"